"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var carCompareTechnic_module_scss_1 = __importDefault(require("./carCompareTechnic.module.scss"));
var react_router_dom_1 = require("react-router-dom");
var formatPrice_1 = require("../../helpers/formatPrice");
var ButtonCard_1 = require("../buttonCardOpenModal/ButtonCard");
var Loader_1 = require("../loader/Loader");
//import 'swiper/swiper-bundle.css';
var react_redux_1 = require("react-redux");
var modalSlice_1 = require("../../redux/slice/modalSlice");
var icons_1 = require("@ant-design/icons");
var CarCompareTechnic = function () {
    var _a = (0, react_router_dom_1.useParams)(), brand = _a.brand, model = _a.model;
    var dispatch = (0, react_redux_1.useDispatch)();
    var tableContainerRef = (0, react_1.useRef)(null);
    var tableContainerWrapRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(null), carCompare = _b[0], setCarСompare = _b[1];
    var _c = (0, react_1.useState)(false), isLoading = _c[0], setLoading = _c[1];
    (0, react_1.useEffect)(function () {
        var containerWrap = tableContainerWrapRef.current;
        if (containerWrap) {
            var handleWheel = function (event) {
                if (event.deltaY !== 0) {
                    event.preventDefault();
                    var container = tableContainerRef.current;
                    container === null || container === void 0 ? void 0 : container.scrollBy({
                        left: event.deltaY < 0 ? -100 : 100,
                        behavior: 'smooth',
                    });
                }
            };
            var enableHorizontalScroll = function () {
                containerWrap === null || containerWrap === void 0 ? void 0 : containerWrap.addEventListener('wheel', handleWheel, { capture: true, passive: false });
            };
            var disableHorizontalScroll = function () {
                containerWrap === null || containerWrap === void 0 ? void 0 : containerWrap.removeEventListener('wheel', handleWheel);
            };
            containerWrap === null || containerWrap === void 0 ? void 0 : containerWrap.addEventListener('mouseenter', enableHorizontalScroll);
            containerWrap === null || containerWrap === void 0 ? void 0 : containerWrap.addEventListener('mouseleave', disableHorizontalScroll);
            return function () {
                containerWrap === null || containerWrap === void 0 ? void 0 : containerWrap.removeEventListener('mouseenter', enableHorizontalScroll);
                containerWrap === null || containerWrap === void 0 ? void 0 : containerWrap.removeEventListener('mouseleave', disableHorizontalScroll);
            };
        }
    }, []);
    (0, react_1.useEffect)(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/car_catalogs/").concat(model === null || model === void 0 ? void 0 : model.split('_')[1], "/compare"))];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        result = _a.sent();
                        setCarСompare(result);
                        setLoading(false);
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, []);
    return (react_1.default.createElement("div", { ref: tableContainerWrapRef, className: carCompareTechnic_module_scss_1.default.compare_technic__container },
        react_1.default.createElement("div", { className: carCompareTechnic_module_scss_1.default.compare_technic__title_wrapper },
            react_1.default.createElement("h2", { className: carCompareTechnic_module_scss_1.default.compare_technic__complectation_title }, "\u0421\u0440\u0430\u0432\u043D\u0435\u043D\u0438\u0435 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u0439 ".concat(brand, " ").concat(model === null || model === void 0 ? void 0 : model.split('_')[0]))),
        react_1.default.createElement("div", { className: carCompareTechnic_module_scss_1.default.compare_technic__complectation_table }, isLoading ? (react_1.default.createElement(Loader_1.Loader, null)) : (carCompare === null || carCompare === void 0 ? void 0 : carCompare.groups.length) !== 0 ? (react_1.default.createElement("div", { ref: tableContainerRef, className: carCompareTechnic_module_scss_1.default.compare_technic__table_container },
            react_1.default.createElement("table", null,
                react_1.default.createElement("tbody", null,
                    react_1.default.createElement("tr", { className: carCompareTechnic_module_scss_1.default.compare_technic__complictation_title },
                        react_1.default.createElement("th", { className: carCompareTechnic_module_scss_1.default.compare_technic__complictation_first }, "\u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044F"), carCompare === null || carCompare === void 0 ? void 0 :
                        carCompare.configurations.map(function (configuration, index) {
                            var package_name = configuration.package_name, volume = configuration.volume, power = configuration.power, special_price = configuration.special_price;
                            return (react_1.default.createElement("th", { key: "".concat(package_name, "_").concat(index) },
                                react_1.default.createElement("div", { className: carCompareTechnic_module_scss_1.default.compare_technic__table_description },
                                    react_1.default.createElement("div", null, package_name),
                                    react_1.default.createElement("div", null, "".concat(volume, " / ").concat(power, " \u043B.\u0441. /")),
                                    react_1.default.createElement("div", null,
                                        "\u043E\u0442 ",
                                        (0, formatPrice_1.formatPrice)(special_price),
                                        " \u20BD"),
                                    react_1.default.createElement(ButtonCard_1.ButtonCardOpenModal, { textContent: "\u0417\u0430\u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C", handler: function () {
                                            dispatch((0, modalSlice_1.openModal)('catalogOrder'));
                                            dispatch((0, modalSlice_1.setOrderType)('book'));
                                        } }))));
                        })), carCompare === null || carCompare === void 0 ? void 0 :
                    carCompare.groups.map(function (group, index) {
                        var group_name = group.group_name, features = group.features;
                        return (react_1.default.createElement(react_1.default.Fragment, { key: "group_".concat(index) },
                            react_1.default.createElement("tr", { className: carCompareTechnic_module_scss_1.default.compare_technic__group_title },
                                react_1.default.createElement("td", null, group_name), carCompare === null || carCompare === void 0 ? void 0 :
                                carCompare.configurations.map(function (elem, compareIndex) {
                                    return react_1.default.createElement("td", { key: "empty_".concat(index, "_").concat(compareIndex) });
                                })),
                            features.map(function (feature, featureIndex) {
                                var feature_name = feature.feature_name, values = feature.values;
                                return (react_1.default.createElement(react_1.default.Fragment, { key: "feature_".concat(index, "_").concat(featureIndex) },
                                    react_1.default.createElement("tr", { className: carCompareTechnic_module_scss_1.default.compare_technic__feature_titles },
                                        react_1.default.createElement("td", null, feature_name),
                                        values.map(function (value, valueIndex) {
                                            return (react_1.default.createElement("td", { key: "values_".concat(index, "_").concat(featureIndex, "_").concat(valueIndex) }, value === '+' ? (react_1.default.createElement(icons_1.CheckOutlined, { style: { color: '#3e8732' } })) : (react_1.default.createElement(icons_1.MinusOutlined, null))));
                                        }))));
                            })));
                    }))))) : (react_1.default.createElement("div", { className: carCompareTechnic_module_scss_1.default.compare_technic__notification }, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044F\u0445 \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442.")))));
};
exports.default = CarCompareTechnic;
